import ModalBody from '../../Modals/ControlActionModalContent/components/ModalBody/ModalBody';
import Button from '../../Button/Button';
import { useTranslate } from '../../../hooks/context/useTranslate';
import { useModalKeyboard } from '../../../hooks/shortcuts/useModalKeyboard';

interface GuideNavigationModalContentProps {
  onContinue: () => void;
  onSave: () => void;
  onCancel: () => void;
}

const GuideNavigationModalContent = ({
  onContinue,
  onSave,
  onCancel,
}: GuideNavigationModalContentProps) => {
  const { t } = useTranslate();

  // Enter chooses the non-destructive action; leaving without saving always
  // requires an explicit click on Continue.
  useModalKeyboard({ onEnter: onSave });

  return (
    <ModalBody
      header={t('warning')}
      text={t('guide.unsavedNavigationText')}
      buttons={
        <>
          <Button color="danger" onClick={onContinue}>
            {t('guide.continueWithoutSaving')}
          </Button>
          <Button color="primary" onClick={onSave}>
            {t('guide.saveData')}
          </Button>
          <Button color="light" fill="solid" onClick={onCancel}>
            {t('cancel')}
          </Button>
        </>
      }
    />
  );
};

export default GuideNavigationModalContent;
